<template>
  <div class="publish-task-page" v-loading.fullscreen.lock="exporting" element-loading-text="导出中..." element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="page-header">
      <h2 class="page-title">发布任务</h2>
    </div>
    <div class="page-divider"></div>
    <div class="filter-bar">
      <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始时间"
        end-placeholder="结束时间" value-format="YYYY-MM-DD" class="filter-item filter-date" />
      <el-input v-model="filters.taskName" placeholder="任务名称" clearable class="filter-item" @keyup.enter="handleSearch" />
      <el-button type="primary" class="filter-btn" @click="handleSearch">查询</el-button>
      <el-button class="filter-btn" @click="handleReset">重置</el-button>
      <el-button type="primary" class="filter-btn filter-btn-export" @click="handleBatchExport">导出</el-button>
    </div>
    <div v-loading="loading" class="task-table">
      <el-table :data="taskList" style="width: 100%">
        <el-table-column prop="taskName" label="任务名称" min-width="250" align="center" />
        <el-table-column prop="publishTotal" label="上传总数" min-width="100" align="center" />
        <el-table-column prop="publishNot" label="未发布" min-width="100" align="center" />
        <el-table-column prop="publishing" label="发布中" min-width="100" align="center" />
        <el-table-column prop="published" label="已发布" min-width="100" align="center" />
        <el-table-column prop="publishNum" label="发布总数" min-width="100" align="center" />
        <el-table-column label="发布二维码" width="150" align="center">
          <template #default="scope">
            <div v-if="scope.row.publishQrCode" class="placeholder-image">
              <el-image :src="scope.row.publishQrCode" :preview-src-list="[scope.row.publishQrCode]"
                :preview-teleported="true" fit="contain" alt="二维码" />
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250" align="center">
          <template #default="scope">
            <div class="action-buttons">
              <el-button type="text" @click="handleViewVideo(scope.row)">查看视频</el-button>
              <el-button type="text" @click="handleEditTopic(scope.row)">修改话题</el-button>
              <el-button type="text" style="color: #FCBB39" @click="handleExport(scope.row)">导出</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="pagination-wrapper" v-if="total">
      <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize" :total="total"
        layout="total, prev, pager, next" @current-change="handlePageChange" />
    </div> -->
    <el-dialog v-model="topicDialogVisible" title="修改话题" width="500px" :before-close="handleCloseDialog">
      <div class="topic-dialog-content">
        <div v-for="(topic, index) in topicList" :key="index" class="topic-item">
          <span class="topic-label">话题{{ index + 1 }}</span>
          <el-input v-model="topicList[index]" placeholder="话题话题" class="topic-input" />
          <el-button v-if="topicList.length > 1" type="text" link @click="handleDeleteTopic(index)"
            style="color: #f56c6c">删除</el-button>
        </div>
        <div class="add-topic" v-if="topicList.length < 5">
          <el-button type="text" link @click="handleAddTopic">+增加话题</el-button>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="handleCloseDialog">取消</el-button>
          <el-button type="primary" @click="handleConfirmTopic">确认</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default { name: "PublishTask" };
</script>

<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import apiData from "@/api/apiData";

const router = useRouter();
const filters = ref({ taskName: "" });
const dateRange = ref(null);
const currentPage = ref(1);
const pageSize = ref(9999);
const total = ref(0);
const loading = ref(false);
const taskList = ref([]);

const getPublishTaskPage = async () => {
  loading.value = true;
  try {
    const params = {
      pageNum: currentPage.value,
      pageSize: pageSize.value,
      taskName: filters.value.taskName,
    };
    if (dateRange.value && dateRange.value.length === 2) {
      params.startTime = dateRange.value[0];
      const endDate = new Date(dateRange.value[1]);
      endDate.setDate(endDate.getDate() + 1);
      params.endTime = endDate.toISOString().split("T")[0];
    }
    const response = await apiData.publishTaskPage(params);
    const pageData = response?.data || {};
    taskList.value = pageData.records || pageData.list || [];
    total.value = Number(pageData.total || 0);
  } catch (error) {
    taskList.value = [];
    total.value = 0;
    ElMessage.error("任务列表加载失败");
  } finally {
    loading.value = false;
  }
};

const handleSearch = () => {
  currentPage.value = 1;
  getPublishTaskPage();
};
const handleReset = () => {
  dateRange.value = null;
  filters.value.taskName = "";
  currentPage.value = 1;
  getPublishTaskPage();
};
const handlePageChange = (page) => { currentPage.value = page; getPublishTaskPage(); };
const handleViewVideo = (row) => {
  const taskId = row.id || row.taskId;
  if (!taskId) {
    ElMessage.warning("任务ID不存在");
    return;
  }
  const query = { taskId };
  if (dateRange.value && dateRange.value.length === 2) {
    query.startTime = dateRange.value[0];
    query.endTime = dateRange.value[1];
  }
  router.push({ name: "VideoPublish", query });
};
const handleExport = async (row) => {
  const taskId = row.id || row.taskId;
  const taskName = row.taskName || row.name || "任务";
  if (!taskId) {
    ElMessage.warning("任务ID不存在");
    return;
  }
  exporting.value = true;
  const startTime = Date.now();
  const minLoadingTime = 1000; // 最少显示1秒

  try {
    const params = { taskId };
    if (dateRange.value && dateRange.value.length === 2) {
      params.startTime = dateRange.value[0];
      const endDate = new Date(dateRange.value[1]);
      endDate.setDate(endDate.getDate() + 1);
      params.endTime = endDate.toISOString().split("T")[0];
    }
    const response = await apiData.exportLink(params);
    const blob = new Blob([response], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${taskName}-抖音链接.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    // 确保 loading 至少显示 minLoadingTime 毫秒
    const elapsed = Date.now() - startTime;
    if (elapsed < minLoadingTime) {
      await new Promise(resolve => setTimeout(resolve, minLoadingTime - elapsed));
    }
    ElMessage.success("导出成功");
  } catch (error) {
    // 确保 loading 至少显示 minLoadingTime 毫秒
    const elapsed = Date.now() - startTime;
    if (elapsed < minLoadingTime) {
      await new Promise(resolve => setTimeout(resolve, minLoadingTime - elapsed));
    }
    ElMessage.error("导出失败");
  } finally {
    exporting.value = false;
  }
};

const handleBatchExport = async () => {
  if (!taskList.value.length) {
    ElMessage.warning("当前页暂无数据");
    return;
  }
  const taskIds = taskList.value.map(item => item.id || item.taskId).filter(Boolean).join(",");
  if (!taskIds) {
    ElMessage.warning("任务ID不存在");
    return;
  }
  exporting.value = true;
  const startTime = Date.now();
  const minLoadingTime = 1000;

  try {
    const params = { taskId: taskIds };
    if (dateRange.value && dateRange.value.length === 2) {
      params.startTime = dateRange.value[0];
      const endDate = new Date(dateRange.value[1]);
      endDate.setDate(endDate.getDate() + 1);
      params.endTime = endDate.toISOString().split("T")[0];
    }
    const response = await apiData.exportLink(params);
    const blob = new Blob([response], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "任务导出-抖音链接.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    const elapsed = Date.now() - startTime;
    if (elapsed < minLoadingTime) {
      await new Promise(resolve => setTimeout(resolve, minLoadingTime - elapsed));
    }
    ElMessage.success("导出成功");
  } catch (error) {
    const elapsed = Date.now() - startTime;
    if (elapsed < minLoadingTime) {
      await new Promise(resolve => setTimeout(resolve, minLoadingTime - elapsed));
    }
    ElMessage.error("导出失败");
  } finally {
    exporting.value = false;
  }
};

const topicDialogVisible = ref(false);
const topicList = ref([]);
const currentTask = ref(null);
const exporting = ref(false);
const handleEditTopic = async (row) => {
  currentTask.value = row;
  const taskId = row.id || row.taskId;
  if (!taskId) {
    ElMessage.error("任务ID不存在");
    return;
  }
  try {
    const response = await apiData.queryTitle({ taskId });
    const titles = response?.data || [];
    topicList.value = Array.isArray(titles) && titles.length > 0 ? titles : [""];
  } catch {
    topicList.value = [""];
  }
  topicDialogVisible.value = true;
};
const handleAddTopic = () => {
  if (topicList.value.length >= 5) {
    ElMessage.warning("最多只能添加5个话题");
    return;
  }
  topicList.value.push("");
};
const handleDeleteTopic = (index) => {
  if (topicList.value.length <= 1) {
    ElMessage.warning("至少保留一个话题");
    return;
  }
  topicList.value.splice(index, 1);
};
const handleCloseDialog = () => {
  topicDialogVisible.value = false;
  topicList.value = [];
  currentTask.value = null;
};
const handleConfirmTopic = async () => {
  const validTopics = topicList.value.filter(topic => topic && topic.trim());
  if (validTopics.length === 0) {
    ElMessage.warning("至少需要一个话题");
    return;
  }
  if (!currentTask.value?.id && !currentTask.value?.taskId) {
    ElMessage.error("任务ID不存在");
    return;
  }
  try {
    await apiData.updateTitle({
      taskId: currentTask.value.id || currentTask.value.taskId,
      titleList: validTopics
    });
    ElMessage.success("话题修改成功");
    topicDialogVisible.value = false;
    topicList.value = [];
    currentTask.value = null;
  } catch (error) {
    ElMessage.error("话题修改失败");
  }
};

onMounted(() => { getPublishTaskPage(); });
</script>

<style lang="scss" scoped>
.publish-task-page {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 30px 30px 10px;
  border-radius: 25px;
}

.page-header {
  margin-bottom: 16px;
  position: relative;
  padding-left: 12px;
}

.page-header::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 20px;
  background: #409eff;
  border-radius: 0 2px 2px 0;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.page-divider {
  height: 1px;
  background: #e8e8e8;
  margin-bottom: 20px;
}

.filter-bar {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.filter-item {
  width: 210px;
}

.filter-date {
  width: 320px;
}

.filter-btn {
  // width: 80px;
}

.filter-btn-export {
  background: #FCBB39;
  border-color: #FCBB39;
}

.task-table {
  margin-bottom: 20px;
}

.placeholder-image {
  width: 80px;
  height: 50px;
  // background: #f0f0f0;
  border-radius: 4px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.placeholder-image .el-image {
  width: 100% !important;
  height: 100% !important;
  display: block;
}

.placeholder-image .el-image .el-image__inner {
  border-radius: 4px;
  cursor: pointer;
}

.pagination-wrapper {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}

.topic-dialog-content .topic-item {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.topic-label {
  font-size: 14px;
  color: #606266;
  min-width: 50px;
}

.topic-input {
  flex: 1;
}

.add-topic {
  text-align: right;
  margin-top: 16px;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
}
.filter-bar {
  ::v-deep .el-button+.el-button {
    margin-left: 0;
  }
}
</style>
